import { useMutation } from "./urqlHooks";

const SETTLETAXDOCUMENT = `mutation SETTLE_TAX_DOCUMENT($id: String!, $input: TaxDocumentInput!, $companyId: String!) {
    settleTaxDocument(id: $id, input: $input, companyId: $companyId) {
      id
    }
  }`;

export const SettleTaxDocument = () => {
  const [_taxDocument, settleTaxDocument] = useMutation(SETTLETAXDOCUMENT);
  return settleTaxDocument;
};

const EDITOBLIGATION = `mutation EDIT_OBLIGATION($id: String!, $input: ObligationDocumentInput!, $companyId: String!) {
  editObligationDocument(id: $id, input: $input, companyId: $companyId) {
    id
  }
}`;

export const EditObligation = () => {
  const [editObligation, reexecuteMutation] = useMutation(EDITOBLIGATION);
  const { data, fetching, error } = editObligation;
  return { data, fetching, error, reexecuteMutation };
};

const DELETE_MULTIPLE_DOCUMENTS = `mutation DELETE_MULTIPLE_DOCUMENTS($ids: [String!]!, $companyId: String!) {
  deleteDocuments(ids: $ids, companyId: $companyId)
}`;

export const DeleteDocuments = () => {
  const [result, deleteDocuments] = useMutation(DELETE_MULTIPLE_DOCUMENTS);

  const { data, fetching, error } = result;
  return { data, fetching, error, deleteDocuments };
};

const SETTLE_DOCUMENT_AND_POINT = `mutation SETTLE_DOCUMENT_AND_POINT($id: String!, $companyId: String!, $originalAmount: Float!, $remaining: Float!, $isPaid: Boolean!) {
  settleBothDocumentAndPoint(id: $id, companyId: $companyId, originalAmount: $originalAmount, remaining: $remaining, isPaid: $isPaid) {
    id
  }
}`;

export const SettleDocumentAndPoint = () => {
  const [result, reexecuteMutation] = useMutation(SETTLE_DOCUMENT_AND_POINT);

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteMutation };
};

const DELETE_DOCUMENT = `mutation DELETE_DOCUMENT($companyId: String!, $input: [DocumentToDelete!]!) {
  deleteDocument(companyId: $companyId, input: $input)
}`;

export const DeleteDocument = () => {
  const [result, executeMutation] = useMutation(DELETE_DOCUMENT);

  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation };
};